export default __webpack_public_path__ + "assets/apple-touch-icon-87x87-43e9f10.png";